import { render, staticRenderFns } from "./FabricOrderHeader.vue?vue&type=template&id=504435b6"
import script from "./FabricOrderHeader.vue?vue&type=script&lang=js"
export * from "./FabricOrderHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports